"use strict";
var _InsuranceImpl_data, _InsuranceImpl_meta;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../../utils/deserializer"));
const isBefore_1 = tslib_1.__importDefault(require("date-fns/isBefore"));
// Booking Implementation
class InsuranceImpl {
    constructor(response) {
        _InsuranceImpl_data.set(this, []);
        _InsuranceImpl_meta.set(this, {});
        try {
            const data = response.data.data.map((item) => {
                const claim_until = (0, lodash_get_1.default)(item, 'meta.claim_until', '');
                const isValidDate = new Date(claim_until).toString() !== 'Invalid Date';
                if (claim_until && isValidDate) {
                    item.meta.within_claim_period = (0, isBefore_1.default)(new Date(), new Date(claim_until));
                }
                item.attributes['booking_id'] = (0, lodash_get_1.default)(item, 'relationships.booking.data.id', '');
                item.attributes['customer_id'] = (0, lodash_get_1.default)(item, 'relationships.customer.data.id', '');
                item.attributes['item_id'] = (0, lodash_get_1.default)(item, 'relationships.item.data.id', '');
                return item;
            });
            const payload = (0, deserializer_1.default)({ data });
            tslib_1.__classPrivateFieldSet(this, _InsuranceImpl_data, payload.data, "f");
            tslib_1.__classPrivateFieldSet(this, _InsuranceImpl_meta, (0, lodash_get_1.default)(response.data, 'meta', {}), "f");
        }
        catch {
            tslib_1.__classPrivateFieldSet(this, _InsuranceImpl_data, [], "f");
        }
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _InsuranceImpl_data, "f");
    }
    get meta() {
        return tslib_1.__classPrivateFieldGet(this, _InsuranceImpl_meta, "f");
    }
}
_InsuranceImpl_data = new WeakMap(), _InsuranceImpl_meta = new WeakMap();
exports.default = InsuranceImpl;
//# sourceMappingURL=Insurance.js.map